import React from 'react'
import { defaultProps } from './index'
import { ToolbarSection } from '../../editor/Viewport/Sidebar/Toolbar/ToolbarSection'
import { ToolbarItem } from '../../editor/Viewport/Sidebar/Toolbar/ToolbarItem'
import CtaToolbarSection from 'react-pagebuilder/editor/Viewport/Sidebar/Toolbar/CtaToolbarSection'
import ImageToolbarSection from 'react-pagebuilder/editor/Viewport/Sidebar/Toolbar/ImageToolbarSection'

export const HomeHeroSlideSettings = (settingsProps) => {
  return (
    <>
      {!settingsProps.floating && (
        <>
          <ImageToolbarSection defaultProps={defaultProps} />
          <CtaToolbarSection defaultProps={defaultProps} initOpen />
        </>
      )}
    </>
  )
}

export const HomeHeroSlideFloatingSettings = () =>
  React.createElement(HomeHeroSlideSettings, { floating: true })
